import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BcitiTabsComponent } from 'src/app/global/components/common/tabs/tabs.component';
import { AdminPermitDetail } from '../../models/permit.model';
import { I18nString } from '../../models/permit-category.model';

@Component({
    selector: 'app-permit-infos-panel',
    templateUrl: './permit-infos-panel.component.html',
    styleUrls: ['./permit-infos-panel.component.scss'],
})
export class PermitInfosPanelComponent {
    @ViewChild(BcitiTabsComponent) bcitiTabs: BcitiTabsComponent;

    @Input() permit: AdminPermitDetail;

    @Output() permitUpdated = new EventEmitter<void>();

    messagesActive = false;

    private lastActiveTabIndex = 0;

    constructor(private readonly translate: TranslateService) {}

    statusName(name: I18nString | string): string {
        if (!name) return '';
        if (typeof name === 'string') return name;
        const lang = this.translate.currentLang;
        return name[lang] || name.fr || name.en || '';
    }

    getChipBackgroundColor(color: string, opacity = 0.3): string {
        const fallback = 'rgba(0,0,0,0.05)';
        if (!color) return fallback;
        let hex = color.replace('#', '');
        if (/^[0-9a-fA-F]{3}$/.test(hex)) {
            hex = hex
                .split('')
                .map((c) => c + c)
                .join('');
        }
        if (!/^[0-9a-fA-F]{6}$/.test(hex)) return fallback;
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return `rgba(${r},${g},${b},${opacity})`;
    }

    get unreadCitizenCount(): number {
        if (!this.permit?.messages) return 0;
        return this.permit.messages.filter((m) => m.senderType === 'citizen' && !m.readAt).length;
    }

    detectActiveTab(): void {
        if (!this.bcitiTabs?.tabs) return;
        const tabs = this.bcitiTabs.tabs.toArray();
        const activeIndex = tabs.findIndex((t) => t.active);
        if (activeIndex !== this.lastActiveTabIndex) {
            this.lastActiveTabIndex = activeIndex;
            this.messagesActive = activeIndex === 1;
        }
    }

    onPermitUpdated(): void {
        this.permitUpdated.emit();
    }

    onMessagesRead(): void {
        // Set readAt locally on unread citizen messages so the badge clears without a refetch
        if (this.permit?.messages) {
            const now = new Date().toISOString();
            this.permit.messages
                .filter((m) => m.senderType === 'citizen' && !m.readAt)
                .forEach((m) => {
                    m.readAt = now;
                });
        }
    }
}
